import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectSummaryReportModel } from '../project-summary-report.model';
import { PluginModel } from '../../../../plugins/plugin.model';
import { ProjectSummaryReportContext } from '../project-summary-report.context';

@Component({
    selector: 'adm4-project-summary-report-tab-instances',
    template: `
    <div class='full-height-flex'>
      <adm4-project-summary-report-table [reportModel]='reportModel$ | async'
                                         [projectKey]='projectKey$ | async'
                                         [filterText]='searchTerm$ | async'
                                         [reportsNotFound]='reportsNotFound$ | async'
                                         [reportsError]='reportsError$ | async'
                                         [name]='"instances"'
                                         [quickLinkName]='"Instance"'
                                         [plugins]='plugins$ | async'></adm4-project-summary-report-table>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProjectSummaryReportTabInstancesComponent {
  private reportContext = inject(ProjectSummaryReportContext);

  projectKey$: Observable<string | null>;
  reportModel$: Observable<ProjectSummaryReportModel | undefined>;
  plugins$: Observable<PluginModel[]>;
  searchTerm$: Observable<string | undefined>;

  reportsNotFound$: Observable<boolean>;
  reportsError$: Observable<boolean>;

  constructor() {
    const reportContext = this.reportContext;

    this.projectKey$ = reportContext.projectKey$;
    this.reportModel$ = this.reportContext.instancesReport$;
    this.plugins$ = this.reportContext.instancesPlugins$;
    this.searchTerm$ = this.reportContext.searchTerm$;

    this.reportsNotFound$ = this.reportContext.reportsNotFound$;
    this.reportsError$ = this.reportContext.reportsError$;
  }
}
